import { useEffect, useState } from 'react'
import { onReachability } from '../api/client'

export function useDebounced<T>(value: T, ms = 250): T {
  const [v, setV] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms)
    return () => clearTimeout(t)
  }, [value, ms])
  return v
}

export function useOnline(): boolean {
  const [browser, setBrowser] = useState(typeof navigator === 'undefined' ? true : navigator.onLine)
  const [reachable, setReachable] = useState(true)
  useEffect(() => {
    const on = () => { setBrowser(true); setReachable(true) }
    const off = () => setBrowser(false)
    window.addEventListener('online', on)
    window.addEventListener('offline', off)
    const stop = onReachability((online) => { setReachable(online); if (online) setBrowser(true) })
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); stop() }
  }, [])
  return browser && reachable
}
